import { render } from "./TopSellingProductsChart.vue?vue&type=template&id=3b18706c"
import script from "./TopSellingProductsChart.vue?vue&type=script&lang=js"
export * from "./TopSellingProductsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__